// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"45":"a232c563e1a9d14f","159":"5119a025f230e84a","564":"b450367f6e5278fe"}[chunkId] + ".js";
};